import { subscriptionToolId } from '@/consts/configs';
import openOfferScreen from '@/utils/user/openOfferScreen';

import type { CreditCheckResult } from './ensureSufficientCredits';

interface Options {
  /**
   * Force the subscription/upsell variant of the offer screen. Used on the
   * GenAI Studio surface where the subscription is the primary monetization.
   */
  preferSubscription: boolean;
}

/**
 * Translate an ensureSufficientCredits decision into the right offer-screen
 * variant. No-op on sufficient credits or fetch failure.
 */
const openOfferIfInsufficient = (
  result: CreditCheckResult,
  { preferSubscription }: Options
): void => {
  if (result.sufficient || result.reason !== 'insufficient') return;
  const toolId =
    result.isPro || preferSubscription ? subscriptionToolId : undefined;
  openOfferScreen(toolId);
};

export default openOfferIfInsufficient;
